import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Mail, Loader2, ShieldCheck } from "lucide-react";
import { api, setToken } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { useToast } from "../hooks/use-toast";

const AdminLogin = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      toast({ title: "Eksik bilgi", description: "E-posta ve şifre zorunlu." });
      return;
    }
    try {
      setBusy(true);
      const res = await api.post("/auth/login", { email, password });
      setToken(res.data.access_token);
      toast({ title: "Giriş başarılı", description: "Yönetim paneline yönlendiriliyorsunuz." });
      navigate("/admin/dashboard");
    } catch (err) {
      toast({
        title: "Giriş başarısız",
        description: err?.response?.data?.detail || "Sunucuya ulaşılamadı.",
      });
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#b91c1c] via-[#991b1b] to-[#7f1d1d] flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-white shadow-2xl mb-4">
            <ShieldCheck className="w-8 h-8 text-[#b91c1c]" />
          </div>
          <h1 className="text-3xl font-black text-white">Aktav Yarka</h1>
          <p className="text-white/80 text-sm mt-1">Yönetim Paneli Girişi</p>
        </div>

        <form onSubmit={submit} className="bg-white rounded-2xl shadow-2xl p-8 space-y-5">
          <div>
            <label className="text-xs font-semibold text-slate-700 mb-1.5 block">E-posta</label>
            <div className="relative">
              <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="alacapartners@gmail.com"
                className="pl-10 h-11"
                autoComplete="username"
              />
            </div>
          </div>
          <div>
            <label className="text-xs font-semibold text-slate-700 mb-1.5 block">Şifre</label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="pl-10 h-11"
                autoComplete="current-password"
              />
            </div>
          </div>
          <Button type="submit" disabled={busy} className="w-full h-11 bg-[#b91c1c] hover:bg-[#991b1b] text-white font-semibold">
            {busy ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : null}
            {busy ? "Giriş yapılıyor..." : "Giriş Yap"}
          </Button>
          <a href="/" className="block text-center text-xs text-slate-500 hover:text-slate-800">
            ← Siteye dön
          </a>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
